module.exports = __webpack_public_path__ + "img/logo1.1346df7d.jpg";